import {useUpdateUserStatus} from '@/modules/users/api'
import {useCan} from '@/shared/hooks/use-permissions'
import {ResourceDrawerSummary} from '@/shared/components/ui/resource-drawer-summary'
import {useUserContext} from '@/shared/contexts'
import {Avatar} from '@chakra-ui/react'

export function UserSummary() {
  const {user} = useUserContext()
  const updateStatus = useUpdateUserStatus()
  const canManageUsers = useCan('users.manage')

  return (
    <ResourceDrawerSummary
      title={user.name}
      description={`@${user.username}`}
      status={user.status}
      icon={<Avatar.Fallback name={user.name} />}
      {...(canManageUsers && {onChangeStatus: status => updateStatus({id: user.id, status})})}
    />
  )
}
